export const SET_OCCUPANCY_DATA = 'SET_OCCUPANCY_DATA';

export default {
    [SET_OCCUPANCY_DATA]: (state, payload) => {
        state.occupancyData = payload;
    },
};
